import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import SafeImage from './SafeImage';

const DestinationGrid = ({ title, items }) => {
  const ref = useRef(null);
  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * 340, behavior: 'smooth' });
  };

  return (
    <section className="py-12 bg-[#eef4f8]">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">{title}</h2>

        <div className="relative">
          <button
            onClick={() => scroll(-1)}
            className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0d64a8] text-white items-center justify-center shadow-lg hover:bg-[#0a548e]"
            aria-label="prev"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0d64a8] text-white items-center justify-center shadow-lg hover:bg-[#0a548e]"
            aria-label="next"
          >
            <ChevronRight size={20} />
          </button>

          <div ref={ref} className="flex gap-5 overflow-x-auto snap-x scroll-smooth pb-3" style={{ scrollbarWidth: 'none' }}>
            {items.map((c) => (
              <Link
                to={`/destination/${c.slug}`}
                key={c.slug}
                className="snap-start shrink-0 w-[260px] md:w-[290px] h-[260px] relative rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition"
              >
                <SafeImage src={c.image} alt={c.name} fallbackType={c.fbType || 'default'} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-0 right-0 text-center text-white text-lg font-semibold">
                  {c.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DestinationGrid;
